export default {
    category: "子類列表：",
    brand: "選擇品牌：",
    nomore: "暫無更多選擇",
    sort1: "默認",
    sort2: "銷量",
    sort3: "價格",
    sort4: "上架時間",
    mode: "顯示方式：",
    collection1: "收藏",
    collection2: "取消收藏",
    collection3: "收藏成功！",
    collection4: "取消收藏成功！",
    nothing: "暫無商品",
    recommend: "為你推薦",
}